import { useDismissProductAnnouncementMutation } from '@cartwheel/api/v1'
import { Button, Modal } from '@cartwheel/components'
import { useState } from 'react'

export interface ProductUpdate {
  title: string
  description: string
}

export interface ProductUpdateAnnouncementModalProps {
  show: boolean
  version: string
  updates: ProductUpdate[]
}

function MegaphoneIcon() {
  return (
    <span
      className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mint-25 text-forest"
      aria-hidden="true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-5 w-5"
        aria-hidden="true"
      >
        <path d="M3 10v4a1 1 0 0 0 1 1h1.6l2.7 3.6A1 1 0 0 0 10 18v-3h.3l7.2 2.9A2 2 0 0 0 20 16V8a2 2 0 0 0-2.5-1.9L10.3 9H10V6a1 1 0 0 0-1.7-.7L5.6 9H4a1 1 0 0 0-1 1Zm17.5 1.1a2.5 2.5 0 0 1 0 1.8l1.4.6a4 4 0 0 0 0-3l-1.4.6Z" />
      </svg>
    </span>
  )
}

export default function ProductUpdateAnnouncementModal({
  show,
  version,
  updates,
}: ProductUpdateAnnouncementModalProps) {
  const [open, setOpen] = useState(show)
  const { mutate, isPending } = useDismissProductAnnouncementMutation()

  const dismiss = () => {
    mutate(
      {},
      {
        onSuccess: () => setOpen(false),
      }
    )
  }

  if (!open) return null

  return (
    <div data-announcement-version={version}>
      <Modal
        isOpen={open}
        onClose={dismiss}
        title={
          <span className="flex items-center gap-3">
            <MegaphoneIcon />
            <span>What's new at Cartwheel?</span>
          </span>
        }
        footer={
          <div className="flex justify-end pt-2">
            <Button variant="primary" onClick={dismiss} disabled={isPending}>
              Got it!
            </Button>
          </div>
        }
      >
        <ol className="m-0 list-none space-y-0 p-0">
          {updates.map((update, index) => (
            <li
              key={update.title}
              className={index === 0 ? 'border-b border-charcoal-25/20 pb-5' : 'border-0 pt-5'}
            >
              <div className="flex gap-3">
                <span
                  className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-mint-25 font-sans text-sm font-semibold text-forest"
                  aria-hidden="true"
                >
                  {index + 1}
                </span>
                <div className="min-w-0 space-y-1">
                  <p className="m-0 font-sans text-base font-semibold text-charcoal">
                    {update.title}
                  </p>
                  <p className="m-0 font-sans text-sm text-charcoal-50">{update.description}</p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </Modal>
    </div>
  )
}
